import React from 'react';
import styles from './home.module.scss';
import { movieData } from '../../database/movies'


function Home(props:any) {



  const data = movieData.map((element, index) => {
    return <div key={index} className={styles.child}>
      <video className={styles.roundedborder} width="100%"  controls poster={element.thumb} >
        <source src={element.sources[0]} type="video/mp4" />
      </video>
    </div>
  });


  return (
    <div className={styles.container}>
      {data}
    </div>
  );
}


export default Home;
